import { NoResult } from 'ui/illustrations';
import { Link } from 'ui/links';
import { RevenueEmptyContainer, EmptyImage, EmptyInfoContent, EmptyInfoSubText } from './Styled';

export const RevenueEmptyCard = () => (
  <RevenueEmptyContainer data-testid="revenue-metric-empty-state">
    <EmptyImage>
      <NoResult />
    </EmptyImage>
    <EmptyInfoContent>
      {`We haven't found any revenue-related data to share with you `}
    </EmptyInfoContent>
    <EmptyInfoSubText>
      {`Either the data's not being reported or has a $0 value. Learn about `}
      <Link
        hasOpenNewTabIcon
        href="https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-"
        target="_blank"
      >
        Tracking Purchases and Revenue
      </Link>
      .
    </EmptyInfoSubText>
  </RevenueEmptyContainer>
);
